// extracted by mini-css-extract-plugin
export var parcelRow = "_re-0";